import { apiClient } from '../client';
import { API_ENDPOINTS } from '@/utils/constants';
import type { LoginRequest, LoginResponse, User } from '@/types';

// 登录
export const login = async (data?: LoginRequest): Promise<LoginResponse> => {
  const response = await apiClient.post<LoginResponse>(API_ENDPOINTS.AUTH.LOGIN, data);
  return response.data;
};

// 登出
export const logout = async (): Promise<void> => {
  await apiClient.post(API_ENDPOINTS.AUTH.LOGOUT);
};

// 刷新token
export const refreshToken = async (refreshToken: string): Promise<LoginResponse> => {
  const response = await apiClient.post<LoginResponse>(API_ENDPOINTS.AUTH.REFRESH, {
    refreshToken,
  });
  return response.data;
};

// 注册
export const register = async (data: {
  name: string;
  email: string;
  password: string;
}): Promise<User> => {
  const response = await apiClient.post<User>(API_ENDPOINTS.AUTH.REGISTER, data);
  return response.data;
};